export const BASIC_SEO_IMG = 'https://d6bibcz2xnnr9.cloudfront.net/IMG_0305_min_86feaa4553_6d7bad9fa7.jpg';

export const DONATE_LINK = 'https://www.patreon.com/radioplato';
